export const GLOBALSERVERERRORMESSAGE = 'Server is not responding';
export const INVALIDTOKENMESSAGEFROMSERVER = 'Invalid Token';
export const EMPTYMESSAGEFROMSERVER = '';
export const NULLMESSAGEFROMSERVER = null;
export const UNAUTHORIZEDSERVERMESSAGE = "Unauthorized"